module.exports = __webpack_public_path__ + "static/media/170x230.192c801d.png";